 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"arvore":"arvore","apoio-estatisticas":"apoio-estatisticas","avisos":"avisos","canal-anonimo":"canal-anonimo","projeto":"projeto","epicos":"epicos","projetos~queries":"projetos~queries","projetos":"projetos","reclamacoes":"reclamacoes","ticket":"ticket","tickets-estatisticas":"tickets-estatisticas","tickets-finalizados":"tickets-finalizados","tickets-pgd":"tickets-pgd","tickets-quarentena":"tickets-quarentena","tickets-status":"tickets-status","usuario":"usuario","configuracoes":"configuracoes","usuarios":"usuarios","clientes":"clientes","dashboard":"dashboard","error":"error","login":"login","queries":"queries","tools":"tools"}[chunkId]||chunkId) + "." + {"arvore":"ef5fa557","chunk-07656b56":"e00df969","chunk-0b759c92":"d68dd37a","chunk-1676f170":"dac1f554","chunk-5ea059e5":"a5af5ae2","chunk-712aad51":"61ecd488","chunk-74d4e65f":"b65a4c1f","apoio-estatisticas":"86c595c7","avisos":"556ed9a2","canal-anonimo":"0e452e29","chunk-07059fa0":"e684956d","chunk-e3edfdc8":"3f8a23bd","chunk-2caac702":"51e3ff6e","chunk-2d0e51ff":"3101fd95","chunk-2118a3f6":"4a815e9f","projeto":"1e752f83","chunk-40599b83":"754e4e80","chunk-53b87658":"ad2d96d6","chunk-565d5c32":"c6303420","chunk-86bbee72":"c7504278","chunk-9a5abbf4":"ae7f14f8","chunk-a5676c7e":"17a38abe","chunk-cec615ce":"813184c0","epicos":"be290c97","projetos~queries":"315cc0c8","projetos":"b99c8322","reclamacoes":"f20e7f38","ticket":"5798bf61","tickets-estatisticas":"c19ebf74","tickets-finalizados":"71ee33f5","tickets-pgd":"95759dcb","tickets-quarentena":"350d3ce9","tickets-status":"60fabefd","usuario":"cfc4cc63","configuracoes":"ca3e6bd2","usuarios":"39407bb1","chunk-2149f4b8":"a774d4ae","chunk-2d0b6109":"8a05b7e3","chunk-2d0bd9e4":"1ccab6ee","chunk-2d0be68f":"8594f70d","chunk-2d0c1f58":"83cc0a50","chunk-2d0cba26":"6cfdf651","chunk-2d208349":"374ea19e","chunk-34c76284":"1c7aa85c","chunk-3d8160c8":"d6213ee7","chunk-3db7a539":"22d1985d","chunk-3e760308":"89ddfef1","chunk-49a4aff4":"073a22c0","chunk-50a27104":"1c49371a","chunk-5c63143a":"851d8c32","chunk-60d45bb6":"e12bd743","chunk-7d96c64c":"6a70a5ef","chunk-7db13048":"eb1ff8b0","chunk-b54d466c":"479bb982","chunk-f6bff122":"4c461ca4","clientes":"5c32cc2b","dashboard":"6f45bd1b","error":"302b0be0","login":"444fbbbf","queries":"83732905","tools":"cd494a9e","chunk-4453c1c5":"7ae1e8ac","chunk-2d0cb704":"98dce6a6","chunk-702ad273":"8f6b4677","chunk-2d0e2664":"f18de8ba","chunk-2d0e97b4":"bd321ca6","chunk-43a6e368":"4aa6d321","chunk-2d0aa93b":"10476ddb","chunk-2d0b59d4":"73602fad","chunk-ac909226":"89c79a0c","chunk-3837c853":"0ee8990c","chunk-72c34cf7":"df9320f9","chunk-0e17eea0":"071e4657","chunk-12b0d88c":"a2726b91","chunk-2d0cfa65":"9a6fc485","chunk-3af127ee":"758eeab5","chunk-3df48392":"9f295c5e","chunk-7e06e12f":"b9875410","chunk-90670180":"0bf84887","chunk-c043484e":"acfe0ffd","chunk-cee7cdaa":"e01c59c0","chunk-2d0db093":"f2b6e604","chunk-14adf04f":"3dc3c4ac","chunk-2d216227":"179c93ce","chunk-2d0a555d":"c6860249","chunk-fcf40eee":"355b5df5","chunk-676faf82":"f41f45ce","chunk-87627ec6":"6c739fa6","chunk-87b82b0c":"6563098f","chunk-87df9b34":"3a4d9947","chunk-87e68bce":"0057c37a","chunk-8a1f7a3a":"8dec3a81","chunk-c54de6c4":"1c1c8a34","chunk-2d2165b8":"a2346357","chunk-3afe79c2":"22f54d1f","chunk-6f35ffdc":"36c22f5d","chunk-17e625a8":"368106c4","chunk-206c59b3":"2dabbe62","chunk-2d0aa616":"e5fb02c1","chunk-2d0b271c":"cc963a97","chunk-2d0b2b29":"e953a7c2","chunk-2d0dee69":"32d15326","chunk-10809142":"c797182a","chunk-6e95cde0":"84bac60d","chunk-284b5628":"f143d068","chunk-d0653d0c":"8196e021","chunk-7eed2946":"4a3a98ca","chunk-2d0aa5b8":"d5ad4c78","chunk-15d61e48":"6b560ab7","chunk-2d0f083e":"502c6ff6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"arvore":1,"chunk-1676f170":1,"chunk-5ea059e5":1,"apoio-estatisticas":1,"avisos":1,"chunk-07059fa0":1,"chunk-2caac702":1,"chunk-2118a3f6":1,"chunk-53b87658":1,"chunk-a5676c7e":1,"epicos":1,"projetos":1,"ticket":1,"tickets-finalizados":1,"tickets-quarentena":1,"tickets-status":1,"usuario":1,"configuracoes":1,"usuarios":1,"chunk-2149f4b8":1,"chunk-34c76284":1,"chunk-3d8160c8":1,"chunk-3db7a539":1,"chunk-49a4aff4":1,"chunk-50a27104":1,"chunk-60d45bb6":1,"chunk-7db13048":1,"chunk-b54d466c":1,"queries":1,"tools":1,"chunk-72c34cf7":1,"chunk-0e17eea0":1,"chunk-12b0d88c":1,"chunk-3af127ee":1,"chunk-3df48392":1,"chunk-7e06e12f":1,"chunk-90670180":1,"chunk-c043484e":1,"chunk-cee7cdaa":1,"chunk-14adf04f":1,"chunk-fcf40eee":1,"chunk-676faf82":1,"chunk-87627ec6":1,"chunk-8a1f7a3a":1,"chunk-c54de6c4":1,"chunk-3afe79c2":1,"chunk-10809142":1,"chunk-6e95cde0":1,"chunk-284b5628":1,"chunk-d0653d0c":1,"chunk-7eed2946":1,"chunk-15d61e48":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"arvore":"arvore","apoio-estatisticas":"apoio-estatisticas","avisos":"avisos","canal-anonimo":"canal-anonimo","projeto":"projeto","epicos":"epicos","projetos~queries":"projetos~queries","projetos":"projetos","reclamacoes":"reclamacoes","ticket":"ticket","tickets-estatisticas":"tickets-estatisticas","tickets-finalizados":"tickets-finalizados","tickets-pgd":"tickets-pgd","tickets-quarentena":"tickets-quarentena","tickets-status":"tickets-status","usuario":"usuario","configuracoes":"configuracoes","usuarios":"usuarios","clientes":"clientes","dashboard":"dashboard","error":"error","login":"login","queries":"queries","tools":"tools"}[chunkId]||chunkId) + "." + {"arvore":"cb8c324f","chunk-07656b56":"31d6cfe0","chunk-0b759c92":"31d6cfe0","chunk-1676f170":"e7a656d3","chunk-5ea059e5":"34f16da1","chunk-712aad51":"31d6cfe0","chunk-74d4e65f":"31d6cfe0","apoio-estatisticas":"042b7764","avisos":"a715a0cd","canal-anonimo":"31d6cfe0","chunk-07059fa0":"55e94a1f","chunk-e3edfdc8":"31d6cfe0","chunk-2caac702":"7e181a86","chunk-2d0e51ff":"31d6cfe0","chunk-2118a3f6":"5770e024","projeto":"31d6cfe0","chunk-40599b83":"31d6cfe0","chunk-53b87658":"69d01c66","chunk-565d5c32":"31d6cfe0","chunk-86bbee72":"31d6cfe0","chunk-9a5abbf4":"31d6cfe0","chunk-a5676c7e":"5b510592","chunk-cec615ce":"31d6cfe0","epicos":"47e94cc7","projetos~queries":"31d6cfe0","projetos":"8f30c735","reclamacoes":"31d6cfe0","ticket":"0f9d567b","tickets-estatisticas":"31d6cfe0","tickets-finalizados":"fea7f710","tickets-pgd":"31d6cfe0","tickets-quarentena":"0dfe3dd7","tickets-status":"a36c1b78","usuario":"bd42a8db","configuracoes":"7e2ce2d5","usuarios":"a4273378","chunk-2149f4b8":"c8f3d495","chunk-2d0b6109":"31d6cfe0","chunk-2d0bd9e4":"31d6cfe0","chunk-2d0be68f":"31d6cfe0","chunk-2d0c1f58":"31d6cfe0","chunk-2d0cba26":"31d6cfe0","chunk-2d208349":"31d6cfe0","chunk-34c76284":"b2850ab4","chunk-3d8160c8":"3fe54a07","chunk-3db7a539":"3214aac7","chunk-3e760308":"31d6cfe0","chunk-49a4aff4":"623a99fb","chunk-50a27104":"86a835a8","chunk-5c63143a":"31d6cfe0","chunk-60d45bb6":"24f0b460","chunk-7d96c64c":"31d6cfe0","chunk-7db13048":"9a6a72b2","chunk-b54d466c":"178e6671","chunk-f6bff122":"31d6cfe0","clientes":"31d6cfe0","dashboard":"31d6cfe0","error":"31d6cfe0","login":"31d6cfe0","queries":"d8e501c8","tools":"cfbc0e93","chunk-4453c1c5":"31d6cfe0","chunk-2d0cb704":"31d6cfe0","chunk-702ad273":"31d6cfe0","chunk-2d0e2664":"31d6cfe0","chunk-2d0e97b4":"31d6cfe0","chunk-43a6e368":"31d6cfe0","chunk-2d0aa93b":"31d6cfe0","chunk-2d0b59d4":"31d6cfe0","chunk-ac909226":"31d6cfe0","chunk-3837c853":"31d6cfe0","chunk-72c34cf7":"042b7764","chunk-0e17eea0":"3599b660","chunk-12b0d88c":"b512dab6","chunk-2d0cfa65":"31d6cfe0","chunk-3af127ee":"46c0be61","chunk-3df48392":"96ecc607","chunk-7e06e12f":"0e7bd4f4","chunk-90670180":"524e9aeb","chunk-c043484e":"df6d67b4","chunk-cee7cdaa":"77aa7aa8","chunk-2d0db093":"31d6cfe0","chunk-14adf04f":"cb0524bb","chunk-2d216227":"31d6cfe0","chunk-2d0a555d":"31d6cfe0","chunk-fcf40eee":"eeff440f","chunk-676faf82":"601c0c03","chunk-87627ec6":"d2fdf26c","chunk-87b82b0c":"31d6cfe0","chunk-87df9b34":"31d6cfe0","chunk-87e68bce":"31d6cfe0","chunk-8a1f7a3a":"17924bfa","chunk-c54de6c4":"190664d9","chunk-2d2165b8":"31d6cfe0","chunk-3afe79c2":"0121b9b0","chunk-6f35ffdc":"31d6cfe0","chunk-17e625a8":"31d6cfe0","chunk-206c59b3":"31d6cfe0","chunk-2d0aa616":"31d6cfe0","chunk-2d0b271c":"31d6cfe0","chunk-2d0b2b29":"31d6cfe0","chunk-2d0dee69":"31d6cfe0","chunk-10809142":"c52694a0","chunk-6e95cde0":"a33a18a0","chunk-284b5628":"d1607ff2","chunk-d0653d0c":"08623278","chunk-7eed2946":"20e269cd","chunk-2d0aa5b8":"31d6cfe0","chunk-15d61e48":"178e6671","chunk-2d0f083e":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
